import { UploadStatus } from '@aus-platform/design-system';
import { ImageSetUploadStage } from '../enums';

const uploadStatusByStage: Record<ImageSetUploadStage, UploadStatus> = {
  [ImageSetUploadStage.Queued]: UploadStatus.Pending,
  [ImageSetUploadStage.Starting]: UploadStatus.Pending,
  [ImageSetUploadStage.Uploading]: UploadStatus.InProgress,
  [ImageSetUploadStage.Completing]: UploadStatus.InProgress,
  [ImageSetUploadStage.NetworkError]: UploadStatus.NetworkError,
  [ImageSetUploadStage.Paused]: UploadStatus.Paused,
  [ImageSetUploadStage.Uploaded]: UploadStatus.Completed,
  [ImageSetUploadStage.Failed]: UploadStatus.Error,
  [ImageSetUploadStage.Cancelled]: UploadStatus.Cancelled,
};

export const mapImageSetStageToUploadStatus = (
  stage: ImageSetUploadStage,
): UploadStatus => uploadStatusByStage[stage];
